/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  apiUrlBase: 'https://ealcazar-back.deptapps.automation-coe.com/api',
  oktaApiUrlBase: 'https://dev-back.deptapps.automation-coe.com/okta/auth',
  webSocketUrlBase: 'https://ealcazar-back.deptapps.automation-coe.com/wsapi',
  impersonateToken: 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJub25lIiwicmVxdWVzdGVkX2Zyb20iOiJkZXB0YXBwcy1wcm9kIiwicmVxdWVzdGVkX2J5IjoiZ21hcmFub25AZW1lYWwubnR0ZGF0YS5jb20iLCJpbXBlcnNvbmF0ZSI6dHJ1ZSwiaXNzIjoibWRvbmUtcHJvZCIsImltcGVyc29uYXRlX21ldGFfaW5mb3JtYXRpb24iOnsidHJhbnN2ZXJzYWxBY2Nlc3NSZXNvdXJjZXMiOnsiZGVwdEFwcElBTm9kZUZsb3dzQkVSVERpY3Rpb25hcnlJZHMiOltdfSwiaWREZXB0QXBwIjoyNDI5LCJpZERlcHRBcHBWZXJzaW9uIjoxMjY1MjN9LCJyZXF1ZXN0X2lkIjoiZDEwMTI1ZDgtZjYwMy00YmM3LWFlZDEtOTU0Nzc0NjhjNGY3IiwiaWF0IjoxNzIxMTI2NzI1LCJqdGkiOiJjNTUxNjI5OS0wZWQwLTQ5Y2UtYjNkMy0xMmVkNWI5NTE4NzEifQ.hHTH_VUwtRN4L9-QeHBPRIGbN6JEFDsrnu3dUrOGWao6pJ6xVEfL-kXMkN7kTvlhBcmQdJz4CP4r98o6POykLw',
};
